<script setup>
import { UnorderedListOutlined } from '@ant-design/icons-vue';
import { gql } from 'graphql-tag';
import { GqlQuery } from '~/lib/fw';
import PERFIL_ACESSO from '~/perfilAcesso';

const gerenciaGql = gql`
  query gerenciaQuery {
    cache(where: { partitionKey: { eq: "Belem" } }) {
      key
      value
    }
  }
`;

const gqlDatatableVars = {
  where: {
    and: [
      {
        responsavel: {
          perfisAcesso: {
            some: {
              perfil: {
                in: [PERFIL_ACESSO.Belem],
              },
            },
          },
        },
      },
    ],
  },
};
</script>

<template>
  <Page menu="belem">
    <div class="belem-page" style="padding-bottom: 24px">
      <a-row justify="center">
        <a-col :xs="24" :md="24" :lg="24" :xl="24">
          <a-row>
            <a-col :span="12">
              <h1>
                <UnorderedListOutlined
                  style="color: #bebcbc; font-size: 18px"
                />
                Belém
              </h1>
            </a-col>
            <a-col :span="12" />
          </a-row>

          <a-tabs :animated="false" :destroy-inactive-tab-pane="true">
            <a-tab-pane key="pastas" tab="Geral">
              <GqlQuery
                :query-key="['Belem']"
                :query="gerenciaGql"
                :retry="false"
                :remove-cache-on-unmount="true"
              >
                <template #loading>
                  <GestaoLoadingSkeleton />
                </template>
                <template #default="{ data, isFetching }">
                  <a-spin :spinning="isFetching">
                    <GestaoDashboardView
                      gerencia="Belem"
                      :data="data.cache"
                    ></GestaoDashboardView>
                  </a-spin>
                </template>
              </GqlQuery>
            </a-tab-pane>
            <a-tab-pane key="compromissos" tab="Compromissos">
              <CompromissoGqlDatatable
                :enable-row-selection="true"
                :variables="gqlDatatableVars"
              />
            </a-tab-pane>
          </a-tabs>
        </a-col>
      </a-row>
    </div>
  </Page>
</template>
